<h2 mat-dialog-title>{{ data.title || "Confirm" }}</h2>

<div mat-dialog-content>
  {{ data.message }}
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">
    {{ data.cancelText || "Cancel" }}
  </button>
  <button mat-flat-button color="warn" (click)="onConfirm()">
    {{ data.confirmText || "Yes" }}
  </button>
</div>
